module.exports = __webpack_public_path__ + "img/sv27on.27c75dda.svg";